import React, { useState, useRef } from "react";
import { createPortal } from "react-dom";

interface ToolTipProps {
  content: string;
  children: React.ReactNode;
  position?: "top" | "right" | "bottom" | "left";
  delay?: number;
  stickyClick?: boolean;
  iconPositionCenter?: boolean;
}

const TooltipWrapper: React.FC<ToolTipProps> = ({
  content,
  delay = 100,
  children,
  position = "top",
  stickyClick = false,
  iconPositionCenter = false,
}) => {
  const [isActive, setActive] = useState(false);
  const [clickedin, setClickedin] = useState(false);
  const [coords, setCoords] = useState<DOMRect | null>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const timeout = useRef<number>(0);

  function showTip() {
    timeout.current = window.setTimeout(() => {
      if (wrapperRef.current) {
        setCoords(wrapperRef.current.getBoundingClientRect());
        setActive(true);
      }
    }, delay);
  }

  function hideTip() {
    if (!clickedin) {
      clearTimeout(timeout.current);
      setActive(false);
    }
  }

function toggle() {
  setClickedin(prev => {
    const next = !prev;
    setActive(next);
    return next;
  });
}


  const getPositionStyle = () => {
    if (!coords) return {};

    const gap = 8;

    switch (position) {
      case "top":
        return {
          top: coords.top - gap,
          left: coords.left + coords.width / 2,
          transform: "translate(-50%, -100%)",
        };
      case "bottom":
        return {
          top: coords.bottom + gap,
          left: coords.left + coords.width / 2,
          transform: "translate(-50%, 0)",
        };
      case "left":
        return {
          top: coords.top + coords.height / 2,
          left: coords.left - gap,
          transform: "translate(-100%, -50%)",
        };
      case "right":
        return {
          top: coords.top + coords.height / 2,
          left: coords.right + gap,
          transform: "translate(0, -50%)",
        };
    }
  };

  return (
    <>
   <div
  ref={wrapperRef}
  className={`tooltip-wrapper ${
    iconPositionCenter ? "tooltip-content-center" : ""
  }`}
  onMouseEnter={showTip}
  onMouseLeave={hideTip}
  onClick={stickyClick ? toggle : () => setActive(false)}
  onClickCapture={() => {
    setActive(false);
    setClickedin(false);
  }}
  style={{ display: "inline-flex" }}
>
  {children}
</div>


      {isActive &&
        content &&
        coords &&
        createPortal(
          <div
            className={`tooltip-tip ${position}`}
            style={{
              position: "fixed",
              zIndex: 9999,
              pointerEvents: "none",
              maxWidth: 240,
              whiteSpace: "normal",
              overflowWrap: "break-word",
              wordBreak: "break-word",
              textAlign: "left",
              ...getPositionStyle(),
            }}
          >
            {content}
          </div>,
          document.body
        )}
    </>
  );
};

export default TooltipWrapper;
